(function () {
  'use strict';
  var el = document.querySelector('[data-cookie-consent]');
  if (!el) return;
  var opener, loading, busy = false;
  var error = el.querySelector('[data-cookie-error]');
  function privacy() {
    if (window.Shopify && Shopify.customerPrivacy) return Promise.resolve(Shopify.customerPrivacy);
    if (loading) return loading;
    loading = new Promise(function (resolve, reject) {
      var timer = setTimeout(function () { reject(new Error('Privacy settings are temporarily unavailable. Please try again.')); }, 10000);
      if (!window.Shopify || !Shopify.loadFeatures) { clearTimeout(timer); reject(new Error('Privacy settings are temporarily unavailable. Please try again.')); return; }
      Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        clearTimeout(timer);
        if (err || !Shopify.customerPrivacy) reject(new Error('Privacy settings could not load. Please try again.'));
        else resolve(Shopify.customerPrivacy);
      });
    }).catch(function (err) { loading = null; throw err; });
    return loading;
  }
  function close() { el.hidden = true; if (opener) opener.focus(); }
  async function record(granted) {
    if (busy) return;
    busy = true; error.hidden = true;
    var buttons = el.querySelectorAll('button'); buttons.forEach(function (b) { b.disabled = true; });
    try {
      var cp = await privacy();
      await new Promise(function (resolve, reject) {
        var timer = setTimeout(function () { reject(new Error('Your choice could not be saved. Please try again.')); }, 10000);
        cp.setTrackingConsent({ analytics: granted, marketing: granted, preferences: granted, sale_of_data: granted }, function (result) {
          clearTimeout(timer);
          if (result && result.error) reject(new Error('Your choice could not be saved. Please try again.')); else resolve();
        });
      });
      close();
    } catch (err) { error.textContent = err.message; error.hidden = false; }
    finally { busy = false; buttons.forEach(function (b) { b.disabled = false; }); }
  }
  el.querySelector('[data-cookie-accept]').addEventListener('click', function () { record(true); });
  el.querySelector('[data-cookie-decline]').addEventListener('click', function () { record(false); });
  el.querySelector('[data-cookie-close]').addEventListener('click', close);
  el.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !busy) close(); });
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-cookie-open]');
    if (trigger) { e.preventDefault(); opener = trigger; el.hidden = false; el.querySelector('button').focus(); privacy().catch(function () {}); }
  });
})();
